import { createSlice } from "@reduxjs/toolkit";
import api from "../../services";
import { API_RESPONSE, PLAYMATEZAPI } from "../../services/apiConstant";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { USERS_LIST } from "helper/constant";
import axios from "axios";

const slice = createSlice({
  name: "auth",
  initialState: {
    userData: null,
    message: "",
    isLoading: false,
    eventData: null,
    otpToken: null,
    userExistingRoles: [],
    configData: null,
  },
  reducers: {
    apiFetching: (state) => {
      state.isLoading = true;
    },
    apiFailed: (state) => {
      state.isLoading = false;
    },
    setUserExistingRoles: (state, action) => {
      state.userExistingRoles = action.payload?.userType;
    },
    setotpToken: (state, action) => {
      state.otpToken = action.payload?.otpToken;
    },
    getConfigSuccess: (state, action) => {
      state.configData = action.payload;
    },

    getNotificationListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.notificationData = action.payload?.data;
      } else {
        state.notificationData.data = state.notificationData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    addRatingReviewsSuccess: (state, action) => {
      let index = state.notificationData.data.findIndex(
        (item) => item?.id == action.payload
      );
      if (index != -1) {
        state.notificationData.data[index].isVenueRated = true;
      }
    },
  },
});

export default slice.reducer;
const {
  apiFetching,
  apiFailed,
  setUserExistingRoles,
  setotpToken,
  getConfigSuccess,
  getNotificationListSuccess,
  addRatingReviewsSuccess,
} = slice.actions;
/**********************ACTIONS************************************************ */
export const login =
  (requestParams, navigate, setIsDialogOpen) => async (dispatch) => {
    dispatch(apiFetching());
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.login}`,

        requestParams,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
          },
        }
      )
      .then((response) => {
        let result = response.data;
        if (
          result.status === API_RESPONSE?.NOTVERIFIED ||
          result.status === API_RESPONSE?.NOTPASSWORD
        ) {
          setIsDialogOpen((isDialogOpen) => ({
            ...isDialogOpen,
            open: true,
            message: result.message,
          }));
        } else if (result.status == API_RESPONSE?.SUCCESS) {
          let userListData = USERS_LIST ? [...USERS_LIST] : [];
          let objIndex = userListData?.findIndex(
            (item) =>
              item?.data?.id == result.data?.id &&
              item?.data?.userType == result.data?.userType
          );

          if (objIndex == -1) {
            userListData.push(result);
          }

          secureLocalStorage.setItem(
            process.env.REACT_APP_USERS_LIST_KEY,
            userListData
          );
          secureLocalStorage.setItem(
            process.env.REACT_APP_TOKEN_STORAGE_KEY,
            result.token
          );
          secureLocalStorage.setItem(
            process.env.REACT_APP_USER_STORAGE_KEY,
            result.data
          );
          navigate("/");
          window.location.reload();
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const checkEmailOrPhoneNumberExistOrNot =
  (requestParams) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.checkEmailOrPhoneNumberExistOrNot}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(setUserExistingRoles(result));
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const sentOtp = (requestParams, setIsDialogOpen) => async (dispatch) => {
  dispatch(apiFetching());
  axios
    .post(
      `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.sentOtp}`,
      requestParams,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
        },
      }
    )
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
        toast.success(result?.message);
        dispatch(setotpToken(result));
        setIsDialogOpen(true);
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const verifyOtp =
  (requestParams, afterValidate, closeDialog) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.verifyOtp}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(setotpToken(result));
          afterValidate();
          closeDialog();
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const registrationUser =
  (requestParams, navigate, setIsDialogOpen) => async (dispatch) => {
    dispatch(apiFetching());
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.registrationUser}`,
        requestParams,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
          },
        }
      )
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          navigate("/login");
          toast.success(result?.message);
          setIsDialogOpen(false);
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const resetPassword = (requestParams, navigate) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.resetPassword}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
        navigate("/login");
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const socialLogin =
  (
    requestParams,
    setUserTypeDialogOpen,
    verifyPhoneEmail,
    navigate,
    setIsDialogOpen
  ) =>
  async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.socialLogin}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          if (requestParams?.userType && requestParams?.userType?.length > 0) {
            let userListData = USERS_LIST ? [...USERS_LIST] : [];
            let objIndex = userListData?.findIndex(
              (item) =>
                item?.data?.id == result.data?.id &&
                item?.data?.userType == result.data?.userType
            );
            if (objIndex == -1) {
              userListData.push(result);
            }

            secureLocalStorage.setItem(
              process.env.REACT_APP_USERS_LIST_KEY,
              userListData
            );
            secureLocalStorage.setItem(
              process.env.REACT_APP_TOKEN_STORAGE_KEY,
              result.token
            );
            secureLocalStorage.setItem(
              process.env.REACT_APP_USER_STORAGE_KEY,
              result.data
            );
            navigate("/");
            window.location.reload();
          } else {
            verifyPhoneEmail();
            setUserTypeDialogOpen(true);
          }
        } else if (
          result.status === API_RESPONSE?.NOTVERIFIED ||
          result.status === API_RESPONSE?.NOTPASSWORD
        ) {
          setIsDialogOpen((isDialogOpen) => ({
            ...isDialogOpen,
            open: true,
            message: result.message,
          }));
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

// change password
export const changePassword =
  (requestParams, handleSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .put(`${PLAYMATEZAPI.changePassword}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          handleSuccess(true);
          toast.success(result.message);
        } else {
          handleSuccess(false);
          toast.error(result.message);
        }
      })
      .catch(() => {
        handleSuccess(false);
        toast.error("Something went wrong!");
        dispatch(apiFailed());
      });
  };

// get config(enums)
export const getConfig = () => async (dispatch) => {
  api
    .get(`${PLAYMATEZAPI.getConfig}`)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
        dispatch(getConfigSuccess(result.data));
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

// upload Images
export const uploadImages = (formData, folderName) => async (dispatch) => {
  try {
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.uploadProofImages}/${folderName}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const result = response.data;

    if (result.status === API_RESPONSE.SUCCESS) {
      return result.data; // ✅ THIS WILL RETURN
    } else {
      toast.error(result.message);
      return null;
    }
  } catch (error) {
    toast.error("Something went wrong!");
    return null;
  }
};

// upload user profile pictures
export const userImageUpload =
  (formData, folderName, type) => async (dispatch) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.userImageUpload}/en/${folderName}/${type}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const result = response.data;

      if (result.status === API_RESPONSE.SUCCESS) {
        return result.data; // ✅ THIS WILL RETURN
      } else {
        toast.error(result.message);
        return null;
      }
    } catch (error) {
      toast.error("Something went wrong!");
      return null;
    }
  };

// delete uploded profile picture image

export const deleteProfileImage = (requestParams) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.deleteProfileImage}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// get notification list
export const getNotificationList =
  (page, perPage, search, setButtonLoading) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .get(
        `${PLAYMATEZAPI.getNotificationList}?page=${page}&perPage=${perPage}&search=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(
            getNotificationListSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result.message);
        }
        setButtonLoading(false);
      })
      .catch(() => {
        setButtonLoading(false);
        dispatch(apiFailed());
      });
  };

// add review rating
export const addRatingReviews =
  (requestParams, setRatingData) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.rating.addRatingReviews, requestParams)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          dispatch(addRatingReviewsSuccess(requestParams?.notificationId));
        } else {
          toast.error(result.message);
        }
        if (setRatingData) {
          setRatingData(() => ({
            loader: false,
          }));
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };
